
import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Paper,
  Checkbox, Snackbar, Alert
} from "@mui/material";
import { localAxiosPut } from "../../../Axios/axios";
import axios from "axios";
import { Spinner } from "../spinner";
import { axiosInstance, localAxiosGet } from "../../../Axios/axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSnackbar } from 'notistack';
import {
  Person,
  Email,
  Cake,
  Phone,
  CheckCircle,
  Cancel,
} from "@mui/icons-material";

const EditEmployeeDetails = ({ open, onClose, userId, organizationId, onEmployeeUpdated, token }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    dateOfBirth: "",
    joiningDate: "",
    department: "",
    departmentName: "",
    team: "",
    teamName: "",
    designation: "",
    designationName: "",
    status: "inActive",
    employmentType: "Full-Time",
    grade: "",
    isManager: false,
    isTeamLead: false,
    location: "",
    locationName: "",
    reportingManager: "",
    roleId: '',
    roleName: '',
    employeeId: ''
  });
  const [originalFormData, setOriginalFormData] = useState({});
  const [departments, setDepartments] = useState([]);
  const [teams, setTeams] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [locations, setLocations] = useState([]);
  const [managerOptions, setManagerOptions] = useState([]);
  const [loadingLocations, setLoadingLocations] = useState(false);
  const [loadingTeams, setLoadingTeams] = useState(false);
  const [loadingDesignations, setLoadingDesignations] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const { enqueueSnackbar } = useSnackbar();
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });
  const [rolesNamesList, setRolesNamesList] = useState([])


  useEffect(() => {
    if (open && userId) {
      setLoading(true);
      fetchUserDetailsFromApi(userId);
      fetchDepartmentsByOrganizationId(organizationId);
      fetchLocationsByOrganizationId(organizationId);
      fetchReportingManagersList();
      fetchRolesList();
    }
  }, [open, userId, organizationId]);

  const fetchUserDetailsFromApi = async (userId) => {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await axiosInstance(localAxiosGet(`/organization/getUserDetailsByUserId?userId=${userId}`, token));

      if (response.data && response.data.status === "SUCCESS" && response.data.message && response.data.message.user) {
        const userData = response.data.message.user;
        const formDataObj = {
          firstName: userData.first_name || "",
          lastName: userData.last_name || "",
          email: userData.email || "",
          phoneNumber: userData.phone_number || "",
          dateOfBirth: userData.dob ? userData.dob.split('T')[0] : "",
          joiningDate: userData.doj ? userData.doj.split('T')[0] : "",
          department: userData.department_id || "",
          departmentName: userData.department || "",
          team: userData.team_id || "",
          teamName: userData.team || "",
          designation: userData.designation_id || "",
          designationName: userData.designation || "",
          status: userData.status === "active" ? "Active" : "inActive",
          employmentType: userData.employment_type || "Full-Time",
          isManager: userData.is_manager || false,
          isTeamLead: userData.is_team_lead || false,
          location: userData.location_id || "",
          locationName: userData.location_name || "",
          reportingManager: userData.report_manager_id || "",
          roleName: userData.role_name || '',
          roleId: userData.role_id || '',
          employeeId: userData.emp_id || ''
        };

        setFormData(formDataObj);
        setOriginalFormData({ ...formDataObj });

        if (userData.department_id) {
          fetchTeamsByDepartmentId(userData.department_id);
        }
        if (userData.team_id) {
          fetchDesignationsByTeamId(userData.team_id);
        }
      }
    } catch (error) {
      console.error("Error fetching employee details:", error);
      enqueueSnackbar('Failed to load employee details', { variant: 'error' });

      if (error.response && error.response.status === 403) {

        onClose();
      } else if (error.response && error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error(`Server error: ${error.response ? error.response.status : 'Unknown'}`);
      }
    } finally {
      setLoading(false);
    }
  };

  const fetchDepartmentsByOrganizationId = async (orgId) => {
    try {
      setLoading(true);
      const token = localStorage.getItem('accessToken');
      const response = await axiosInstance(localAxiosGet(`/organization/getAllDepartmentsByOrganizationId/${orgId}`, token));

      if (response.data && response.data.message && response.data.message.departments) {
        const departmentsData = response.data.message.departments || [];
        const departmentsArray = departmentsData.map(dept => ({
          id: dept.id,
          name: dept.department
        }));
        setDepartments(departmentsArray);
      } else {
        enqueueSnackbar('Unexpected API response format', { variant: 'error' });
        setDepartments([]);
      }
    } catch (error) {
      console.error('Error fetching departments:', error);
      enqueueSnackbar('Failed to load departments', { variant: 'error' });
      setDepartments([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchTeamsByDepartmentId = async (departmentId) => {
    try {
      setLoadingTeams(true);
      const token = localStorage.getItem('accessToken');
      const response = await axiosInstance(localAxiosGet(`/organization/getAllTeamsByDepartmentId/${departmentId}`, token));

      if (response.data && response.data.message && response.data.message.teams) {
        const teamsData = response.data.message.teams || [];
        const teamsArray = teamsData.map(team => ({
          id: team.id,
          name: team.team
        }));
        setTeams(teamsArray);
      } else {
        enqueueSnackbar('Unexpected API response format for teams', { variant: 'error' });
        setTeams([]);
      }
    } catch (error) {
      console.error('Error fetching teams:', error);
      enqueueSnackbar('Failed to load teams', { variant: 'error' });
      setTeams([]);
    } finally {
      setLoadingTeams(false);
    }
  };

  const fetchDesignationsByTeamId = async (teamId) => {
    try {
      setLoadingDesignations(true);
      const token = localStorage.getItem('accessToken');
      const response = await axiosInstance(localAxiosGet(`/organization/getAllDesignationsByTeamId/${teamId}`, token));

      if (response.data && response.data.message && response.data.message.designations) {
        const designationsData = response.data.message.designations || [];
        const designationsArray = designationsData.map(designation => ({
          id: designation.id,
          name: designation.designation
        }));
        setDesignations(designationsArray);
      } else {
        enqueueSnackbar('Unexpected API response format for designations', { variant: 'error' });
        setDesignations([]);
      }
    } catch (error) {
      console.error('Error fetching designations:', error);
      enqueueSnackbar('Failed to load designations', { variant: 'error' });
      setDesignations([]);
    } finally {
      setLoadingDesignations(false);
    }
  };

  const fetchLocationsByOrganizationId = async (orgId) => {
    try {
      setLoadingLocations(true);
      const token = localStorage.getItem('accessToken');
      const response = await axiosInstance(localAxiosGet(`/organization/getAllLocationsByOrgId/${orgId}`, token));

      if (response.data && response.data.message) {
        const locationsData = response.data.message || [];
        const locationsArray = locationsData.map(location => ({
          id: location.id,
          name: location.location_name,
          country: location.country,
          state: location.state,
          city: location.city
        }));
        setLocations(locationsArray);
      } else {
        enqueueSnackbar('Unexpected API response format for locations', { variant: 'error' });
        setLocations([]);
      }
    } catch (error) {
      console.error('Error fetching locations:', error);
      enqueueSnackbar('Failed to load locations', { variant: 'error' });
      setLocations([]);
    } finally {
      setLoadingLocations(false);
    }
  };

  const fetchReportingManagersList = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await axiosInstance(localAxiosGet(`/project/getAllTeamLeadOrManager?organization_id=${organizationId}&is_manager=true&is_team_lead=true`, token));

      if (response.data && response.data.message && response.data.message.users) {
        const managers = [];
        const teamLeads = [];

        response.data.message.users.forEach(user => {
          if (user.user_type === "Manager") {
            managers.push({
              id: user.id,
              name: `${user.first_name} ${user.last_name}(${user.user_type})`,
              userType: user.user_type
            });
          } else if (user.user_type === "Team Lead") {
            teamLeads.push({
              id: user.id,
              name: `${user.first_name} ${user.last_name} (${user.user_type})`,
              userType: user.user_type
            });
          }
        });


        const options = [...managers, ...teamLeads];
        setManagerOptions(options);
      }
    } catch (error) {
      console.error('Error fetching reporting managers:', error);

      setManagerOptions([]);
    }
  };
  const fetchRolesList = async () => {
    try {
      const response = await axiosInstance(localAxiosGet(`/organization/getAllRolesByOrgId?organization_id=${organizationId}`, token));
      setRolesNamesList(response.data.result)
    } catch (error) {
      console.error('Error in fetching roles dropdown', error)
    }
  }



  const handleRoleChange = (e) => {
    const selectedRoleId = e.target.value;
    const selectedRoleDetails = rolesNamesList.find(r => r.id === selectedRoleId);
    setFormData({
      ...formData,
      roleId: selectedRoleId,
      roleName: selectedRoleDetails?.name || ''
    })
  }

  const handleDepartmentChange = (e) => {
    const selectedDeptId = e.target.value;
    const selectedDept = departments.find(d => d.id === selectedDeptId);
    setFormData({
      ...formData,
      department: selectedDeptId,
      departmentName: selectedDept?.name || '',
      team: "",
      designation: ""
    });
    fetchTeamsByDepartmentId(selectedDeptId);
  };

  const handleTeamChange = (e) => {
    const selectedTeamId = e.target.value;
    const selectedTeam = teams.find(t => t.id === selectedTeamId);
    setFormData({
      ...formData,
      team: selectedTeamId,
      teamName: selectedTeam?.name || '',
      designation: ""
    });
    fetchDesignationsByTeamId(selectedTeamId);
  };

  const handleDesignationChange = (e) => {
    const selectedDesignationId = e.target.value;
    const selectedDesignation = designations.find(d => d.id === selectedDesignationId);
    setFormData({
      ...formData,
      designation: selectedDesignationId,
      designationName: selectedDesignation?.name || ''
    });
  };

  const handleLocationChange = (e) => {
    const selectedLocationId = e.target.value;
    const selectedLocation = locations.find(loc => loc.id === selectedLocationId);
    setFormData({
      ...formData,
      location: selectedLocationId,
      locationName: selectedLocation?.name || ''
    });
  };

  const handleUpdateEmployee = async () => {
    setLoading(true);
    const minSpinnerTime = 3000;
    const startTime = Date.now();

    try {
      const changedFields = {};

      const fieldMapping = {
        firstName: 'first_name',
        lastName: 'last_name',
        email: 'email',
        phoneNumber: 'phone_number',
        dateOfBirth: 'dob',
        joiningDate: 'doj',
        department: 'department',
        team: 'team',
        designation: 'designation',
        status: 'status',
        employmentType: 'employment_type',
        location: 'location_id',
        reportingManager: 'report_manager_id',
        roleId: 'role_id',
        employeeId: 'emp_id'
      };

      Object.keys(fieldMapping).forEach(formField => {
        const apiField = fieldMapping[formField];
        const currentValue = formData[formField];
        const originalValue = originalFormData[formField];

        const currentValToCompare = currentValue === '' ? null : currentValue;
        const originalValToCompare = originalValue === '' ? null : originalValue;

        if (currentValToCompare !== originalValToCompare) {
          if (formField === 'status') {
            changedFields[apiField] = currentValue === "Active" ? "active" : "inactive";
          } else if ((formField === 'reportingManager' || formField === 'roleId' || formField === 'employeeId') && currentValue === '') {
            changedFields[apiField] = null;
          } else {
            if (formField === 'employeeId') {
              changedFields[apiField] = currentValue ? String(currentValue).trim() : null;
            } else {
              changedFields[apiField] = currentValue;
            }
          }
        }
      });

      if (Object.keys(changedFields).length === 0) {
        setSnackbar({ open: true, message: 'No changes detected', severity: 'info' });
        setLoading(false);
        return;
      }

      const token = localStorage.getItem('accessToken');
      const response = await axiosInstance(localAxiosPut(
        `/organization/updateEmployeeDetails?userId=${userId}`,
        changedFields,
        token
      ));

      if (response.status === 200 || response.status === 201) {
        setSnackbar({ open: true, message: 'Employee updated successfully', severity: 'success' });

        const elapsed = Date.now() - startTime;
        const remainingTime = minSpinnerTime - elapsed;

        if (remainingTime > 0) {
          setTimeout(() => {
            onEmployeeUpdated();
            onClose();
          }, remainingTime);
        } else {
          onEmployeeUpdated();
          onClose();
        }
      }
    } catch (error) {
      console.error('Error updating employee:', error);
      setLoading(false)

      let message = 'An unknown error occurred';

      if (error.response) {
        if (error.response.status === 403) {
          onClose();
          message = 'Access denied.';
        } else if (error.response.data?.message) {
          // Ensure message is always a string
          const errorMsg = error.response.data.message;
          if (typeof errorMsg === 'string') {
            message = errorMsg;
          } else if (typeof errorMsg === 'object') {
            message = JSON.stringify(errorMsg);
          } else {
            message = String(errorMsg); // Convert to string
          }
        } else {
          message = `Server error: ${error.response.status}`;
        }
      } else if (error.request) {
        message = 'No response from server. Please check your connection.';
      } else {
        message = `Error: ${error.message}`;
      }
     
      
      setShowErrorMessage(true);
      setErrorMessage(message);
      setSnackbar({ open: true, message, severity: 'error' });
    }
  }

  return (
    <div>
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="md"
        fullWidth
      >
        {loading && <Spinner />}
        <DialogTitle sx={{ backgroundColor: "#1565c0", color: "#fff" }}>
          Edit Employee Details
        </DialogTitle>
        <DialogContent sx={{ padding: "24px" }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 3, mt: 2 }}>
            <Typography variant="h6" color="primary">
              Personal Information
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField
                  label="First Name"
                  fullWidth
                  required
                  value={formData.firstName}
                  onChange={(e) =>
                    setFormData({ ...formData, firstName: e.target.value })
                  }
                  InputProps={{
                    startAdornment: <Person sx={{ mr: 1, color: "#1565c0" }} />,
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label="Last Name"
                  fullWidth
                  required
                  value={formData.lastName}
                  onChange={(e) =>
                    setFormData({ ...formData, lastName: e.target.value })
                  }
                  InputProps={{
                    startAdornment: <Person sx={{ mr: 1, color: "#1565c0" }} />,
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label="Email"
                  type="email"
                  fullWidth
                  required
                  value={formData.email}
                  onChange={(e) =>
                    setFormData({ ...formData, email: e.target.value })
                  }
                  InputProps={{
                    startAdornment: <Email sx={{ mr: 1, color: "#1565c0" }} />,
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label="Phone Number"
                  type="tel"
                  fullWidth
                  inputProps={{ maxLength: 10 }}
                  value={formData.phoneNumber}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, ''); // Allow only digits
                    setFormData({ ...formData, phoneNumber: value });
                  }}
                  InputProps={{
                    startAdornment: <Phone sx={{ mr: 1, color: "#1565c0" }} />,
                  }}
                />

              </Grid>
              <Grid item xs={6}>
                <TextField
                  label="Date of Birth"
                  type="date"
                  fullWidth
                  required
                  InputLabelProps={{ shrink: true }}
                  value={formData.dateOfBirth}
                  onChange={(e) =>
                    setFormData({ ...formData, dateOfBirth: e.target.value })
                  }
                  InputProps={{
                    startAdornment: <Cake sx={{ mr: 1, color: "#1565c0" }} />,
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label="Joining Date"
                  type="date"
                  fullWidth
                  required
                  InputLabelProps={{ shrink: true }}
                  value={formData.joiningDate}
                  onChange={(e) =>
                    setFormData({ ...formData, joiningDate: e.target.value })
                  }
                />
              </Grid>
            </Grid>
            <Typography variant="h6" color="primary">
              Professional Information
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <FormControl fullWidth>
                  <InputLabel required>Department</InputLabel>
                  <Select
                    value={formData.department}
                    onChange={handleDepartmentChange}
                    label="Department"
                    disabled={loading}

                  >
                    {departments.length === 0 ? (
                      <MenuItem disabled>
                        No departments available
                      </MenuItem>
                    ) : (
                      departments.map((dept) => (
                        <MenuItem key={dept.id} value={dept.id}>
                          {dept.name}
                        </MenuItem>
                      ))
                    )}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl fullWidth>
                  <InputLabel required>Team</InputLabel>
                  <Select
                    value={formData.team}
                    onChange={handleTeamChange}
                    label="Team"
                    disabled={!formData.department || loadingTeams}

                  >
                    {loadingTeams ? (
                      <MenuItem disabled>Loading teams...</MenuItem>
                    ) : teams.length === 0 ? (
                      <MenuItem disabled>
                        No teams available for this department
                      </MenuItem>
                    ) : (
                      teams.map((team) => (
                        <MenuItem key={team.id} value={team.id}>
                          {team.name}
                        </MenuItem>
                      ))
                    )}
                  </Select>
                </FormControl>
              </Grid>
              {/* <Grid item xs={6}>
              <Paper
                elevation={1}
                sx={{
                  p: 1.5,
                  display: 'flex',
                  alignItems: 'center',
                  borderLeft: formData.isManager ? '4px solid #1565c0' : '4px solid transparent',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    boxShadow: 2,
                    backgroundColor: '#f5f9ff'
                  },
                  opacity: formData.isTeamLead ? 0.6 : 1,
                  cursor: formData.isTeamLead ? 'not-allowed' : 'pointer'
                }}
                onClick={() => {
                  if (!formData.isTeamLead) {
                    setFormData({ ...formData, isManager: !formData.isManager });
                  }
                }}
              >
                <Checkbox
                  checked={formData.isManager}
                  onChange={(e) => {
                    if (!formData.isTeamLead) {
                      setFormData({ ...formData, isManager: e.target.checked });
                    }
                  }}
                  color="primary"
                  sx={{ mr: 1 }}
                  disabled={formData.isTeamLead}
                />
                <Box>
                  <Typography variant="body1" fontWeight={500}>Is Manager</Typography>
                  <Typography variant="caption" color="text.secondary">
                    Can manage team members and approve requests
                  </Typography>
                </Box>
              </Paper>
            </Grid>
            <Grid item xs={6}>
              <Paper
                elevation={1}
                sx={{
                  p: 1.5,
                  display: 'flex',
                  alignItems: 'center',
                  borderLeft: formData.isTeamLead ? '4px solid #1565c0' : '4px solid transparent',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    boxShadow: 2,
                    backgroundColor: '#f5f9ff'
                  },
                  opacity: formData.isManager ? 0.6 : 1,
                  cursor: formData.isManager ? 'not-allowed' : 'pointer'
                }}
                onClick={() => {
                  if (!formData.isManager) {
                    setFormData({ ...formData, isTeamLead: !formData.isTeamLead });
                  }
                }}
              >
                <Checkbox
                  checked={formData.isTeamLead}
                  onChange={(e) => {
                    if (!formData.isManager) {
                      setFormData({ ...formData, isTeamLead: e.target.checked });
                    }
                  }}
                  color="primary"
                  sx={{ mr: 1 }}
                  disabled={formData.isManager}
                />
                <Box>
                  <Typography variant="body1" fontWeight={500}>Is Team Lead</Typography>
                  <Typography variant="caption" color="text.secondary">
                    Can lead team activities and projects
                  </Typography>
                </Box>
              </Paper>
            </Grid> */}
              <Grid item xs={6}>
                <FormControl fullWidth>
                  <InputLabel required>Designation</InputLabel>
                  <Select
                    value={formData.designation}
                    onChange={handleDesignationChange}
                    label="Designation"
                    disabled={!formData.team || loadingDesignations}
                  >
                    {loadingDesignations ? (
                      <MenuItem disabled>Loading Designations...</MenuItem>
                    ) : designations.length === 0 ? (
                      <MenuItem disabled>No designations available for this team</MenuItem>
                    ) : (
                      designations.map((designation) => (
                        <MenuItem key={designation.id} value={designation.id}>
                          {designation.name}
                        </MenuItem>
                      ))
                    )}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl fullWidth>
                  <InputLabel required>Role</InputLabel>
                  <Select
                    value={formData.roleId}
                    label='Role'
                    onChange={handleRoleChange}
                    required
                  >
                    {rolesNamesList.map((role) => (
                      <MenuItem key={role.id} value={role.id}>{role.name}</MenuItem>
                    ))}


                  </Select>
                </FormControl>

              </Grid>
              <Grid item xs={6}>
                <FormControl fullWidth>
                  <InputLabel>Reporting Supervisor</InputLabel>
                  <Select
                    value={formData.reportingManager}
                    onChange={(e) =>
                      setFormData({ ...formData, reportingManager: e.target.value })
                    }
                    label="Reporting Supervisor"
                  >
                    {managerOptions.map((item) => (
                      <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl fullWidth>
                  <InputLabel>Status</InputLabel>
                  <Select
                    value={formData.status}
                    onChange={(e) =>
                      setFormData({ ...formData, status: e.target.value })
                    }
                    label="Status"
                    defaultValue="inActive"
                  >
                    <MenuItem value="inActive">inActive</MenuItem>
                    <MenuItem value="Active">Active</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label="Employee ID"
                  fullWidth
                  value={formData.employeeId || ''} 
                  onChange={(e) => {
                    const value = e.target.value.trim().toUpperCase(); 
                    setFormData({ ...formData, employeeId: value });
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <FormControl fullWidth>
                  <InputLabel>Location</InputLabel>
                  <Select
                    value={formData.location}
                    onChange={handleLocationChange}
                    label="Location"
                    disabled={loadingLocations}
                  >
                    {loadingLocations ? (
                      <MenuItem disabled>Loading locations...</MenuItem>
                    ) : locations.length === 0 ? (
                      <MenuItem disabled>
                        No locations available
                      </MenuItem>
                    ) : (
                      locations.map((location) => (
                        <MenuItem key={location.id} value={location.id}>
                          {location.name} ({location.city}, {location.state})
                        </MenuItem>
                      ))
                    )}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions sx={{ padding: "16px" }}>
          {showErrorMessage && (
            <Box sx={{
              p: 1,
              bgcolor: '#ffebee',
              borderRadius: 1,
              display: 'flex',
              alignItems: 'center',
              color: '#d32f2f'
            }}>
              <Cancel sx={{ mr: 1 }} />
              <Typography variant="body2">{errorMessage}</Typography>
            </Box>
          )}
          <Button
            onClick={onClose}
            variant="outlined"
            color="error"
            startIcon={<Cancel />}
          >
            Cancel
          </Button>
          <Button
            onClick={handleUpdateEmployee}
            variant="contained"
            color="primary"
            startIcon={<CheckCircle />}
            disabled={loading}
          >
            Update Employee
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>

    </div>

  );
};

export default EditEmployeeDetails;